import { createQuery } from '../api/query'
import { OnboardingStatus } from './types'

const keyOnboardingStatus = ['/onboarding/status']
export const useQueryOnboardingStatus = createQuery<OnboardingStatus>({
    key: keyOnboardingStatus,
    url: '/onboarding/status',
})
